import React, { useEffect } from "react";
import Layout from "@/components/Layout";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import FinanceInfoCard from "./components/FinanceInfoCard";
import ProjectDocumentationTable from "@/pages/ProjectDetailsPage/components/ProjectDocumentationTable.tsx";
import NoteSection from "@/pages/ProjectDetailsPage/components/NoteSection";
import ProjectsNavigation from "@/pages/ProjectDetailsPage/components/ProjectsNavigation.tsx";
import { useParams, useNavigate } from "react-router-dom";
import { useProjectsStore } from "@/store/projectsStore.ts";
import { getProjectReq } from "@/api/projectsApi";
import { useAuthStore } from "@/store/authStore.ts";

const FinanceDetailsPage = () => {
  const theme = useTheme();
  const matchesDownLg = useMediaQuery(theme.breakpoints.down("xl"));
  const { id } = useParams();
  const setProjectDetails = useProjectsStore(
    (state) => state.setProjectsDetails
  );
  const projectsIds = useProjectsStore((state) => state.projectsIds);
  const getProjectsIds = useProjectsStore((state) => state.getProjectsIds);
  const navigate = useNavigate();
  const role = useAuthStore((state) => state.role);

  useEffect(() => {
    const getFinanceDetails = async (financeId: string) => {
      try {
        const response = await getProjectReq(Number(financeId));
        setProjectDetails(response?.data?.project);
      } catch (e: any) {
        if (e?.response && e?.response?.status === 404) {
          navigate("/not-found");
        }
        console.error(e);
      }
    };
    if (id) {
      getFinanceDetails(id);
    }
  }, [id]);

  return (
    <Layout>
      <Box
        sx={{
          marginTop: "28px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
        }}
      >
        {matchesDownLg && (
          <Box sx={{ width: "100%", height: "48px", position: "relative" }}>
            <ProjectsNavigation
              navigateTo={(financeId, searchParams) => {
                navigate(`/finance/${financeId}?${searchParams.toString()}`);
              }}
              ids={projectsIds}
              getIds={getProjectsIds}
            />
          </Box>
        )}
        <FinanceInfoCard />
        <ProjectDocumentationTable projectId={Number(id)} isFinancePage />
        <NoteSection />
      </Box>
    </Layout>
  );
};

export default FinanceDetailsPage;
